/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_ThreadsInputs */

const en_svtag_threads = /** @type {(inputs: Svtag_ThreadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#THREADS`)
};

const ar_svtag_threads = /** @type {(inputs: Svtag_ThreadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#خيوط`)
};

const bn_svtag_threads = /** @type {(inputs: Svtag_ThreadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#THREADS`)
};

const de_svtag_threads = /** @type {(inputs: Svtag_ThreadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#THREADS`)
};

const es_svtag_threads = /** @type {(inputs: Svtag_ThreadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#THREADS`)
};

const fr_svtag_threads = /** @type {(inputs: Svtag_ThreadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#THREADS`)
};

const pt_svtag_threads = /** @type {(inputs: Svtag_ThreadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#THREADS`)
};

const zh_svtag_threads = /** @type {(inputs: Svtag_ThreadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#THREADS`)
};

const tr_svtag_threads = /** @type {(inputs: Svtag_ThreadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#THREADS`)
};

const ru_svtag_threads = /** @type {(inputs: Svtag_ThreadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#THREADS`)
};

const pl_svtag_threads = /** @type {(inputs: Svtag_ThreadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#THREADS`)
};

/**
* | output |
* | --- |
* | "#THREADS" |
*
* @param {Svtag_ThreadsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_threads = /** @type {((inputs?: Svtag_ThreadsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_ThreadsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_threads(inputs)
	if (locale === "bn") return bn_svtag_threads(inputs)
	if (locale === "de") return de_svtag_threads(inputs)
	if (locale === "es") return es_svtag_threads(inputs)
	if (locale === "fr") return fr_svtag_threads(inputs)
	if (locale === "pt") return pt_svtag_threads(inputs)
	if (locale === "zh") return zh_svtag_threads(inputs)
	if (locale === "tr") return tr_svtag_threads(inputs)
	if (locale === "ru") return ru_svtag_threads(inputs)
	if (locale === "pl") return pl_svtag_threads(inputs)
	return en_svtag_threads(inputs)
});